(() => {
  'use strict';

  const activeTimers = new WeakMap();

  function updateDeadline(card) {
    const deadline = Date.parse(card.dataset.verifiedDeadline || '');
    const remaining = deadline - Date.now();
    if (!Number.isFinite(deadline) || remaining <= 0) {
      const section = card.closest('.verified-commerce');
      clearInterval(activeTimers.get(card));
      activeTimers.delete(card);
      card.remove();
      if (section && !section.querySelector('.verified-commerce__card')) section.hidden = true;
      return;
    }
    const seconds = Math.floor(remaining / 1000);
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const rest = seconds % 60;
    const label = card.querySelector('[data-verified-countdown]');
    if (!label) return;
    label.textContent = `${card.dataset.countdownPrefix} ${days} ${card.dataset.countdownDay} ${hours} ${card.dataset.countdownHour} ${minutes} ${card.dataset.countdownMinute} ${rest} ${card.dataset.countdownSecond}`;
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-verified-deadline]').forEach((card) => {
      if (activeTimers.has(card)) return;
      updateDeadline(card);
      if (card.isConnected) activeTimers.set(card, window.setInterval(() => updateDeadline(card), 1000));
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-verified-quantity]');
    if (!button) return;
    const input = document.querySelector('.product-main [data-product-form] input[name="quantity"]');
    if (!input || input.disabled) return;
    const quantity = Number(button.dataset.verifiedQuantity);
    if (!Number.isInteger(quantity) || quantity < Number(input.min || 1)) return;
    if (input.max && quantity > Number(input.max)) return;
    input.value = String(quantity);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    input.focus({ preventScroll: true });
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-verified-deadline]').forEach((card) => {
      clearInterval(activeTimers.get(card));
      activeTimers.delete(card);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
